import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import SafeJsonView from './SafeJsonView';

function PropertiesView({ data }) {
  if (!data || typeof data !== 'object') {
    return <Alert severity="info">No data to display</Alert>;
  }

  const formatValue = (value) => {
    if (value === null) return 'null';
    if (value === undefined) return 'undefined';
    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        return `[${value.length} items]`;
      }
      return `{${Object.keys(value).length} fields}`;
    }
    if (typeof value === 'boolean') {
      return value ? 'true' : 'false';
    }
    return String(value);
  };

  return (
    <Box sx={{ maxHeight: '50vh', overflow: 'auto' }}>
      {Object.entries(data).map(([key, value]) => (
        <Box key={key} sx={{ mb: 2, p: 1, bgcolor: 'background.default', borderRadius: 1 }}>
          <Typography variant="subtitle2" color="primary" gutterBottom>
            {key}
          </Typography>
          <Typography 
            variant="body2" 
            sx={{ 
              wordBreak: 'break-all',
              fontFamily: typeof value === 'object' ? 'monospace' : 'inherit'
            }}
          >
            {formatValue(value)}
          </Typography>
          {typeof value === 'object' && value !== null && (
            <Box sx={{ mt: 1, pl: 2, borderLeft: '2px solid', borderColor: 'divider' }}>
              <SafeJsonView data={value} title="Nested data" />
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
}

export default PropertiesView;